import * as React from 'react'
import { createStyles, Theme, WithStyles, withStyles, Grid } from '@material-ui/core'
import { WithI18n, withI18n } from 'src/core/i18n/withI18n'
import { compose } from 'redux'
import { withRouter, RouteComponentProps } from 'react-router'
import { RootState } from 'src/core/redux/reducer'
import { connect } from 'react-redux'
import { WithGlobalProgress } from 'src/type/lib/withGlobalProgress'
import { WithToast, withToast } from 'src/shared/Toast/Toast'
import { withGlobalProgress } from 'src/shared/GlobalProgress'
import Page from 'src/shared/Page/Page'
import autobind from 'autobind-decorator'
import { Helmet } from 'react-helmet'
import IndexMiniChart from 'src/page/Consumer/MarketIndicators/IndexMiniChart'
import { DASHBOARD_INDEX_CONFIG } from 'src/page/Consumer/MarketIndicators/IndexConfigs'
import MailNotification from 'src/page/Consumer/MailNotification/MailNotification'

import DashboardCotations from 'src/page/Consumer/Dashboard/tabs/DashboardCotations'
import DashboardTransactions from 'src/page/Consumer/Dashboard/tabs/DashboardTransactions'
import DashboardNews from 'src/page/Consumer/Dashboard/tabs/DashboardNews'
import DashboardHabilitations from 'src/page/Consumer/Dashboard/tabs/DashboardHabilitations'
import DashboardSignatures from 'src/page/Consumer/Dashboard/tabs/DashboardSignatures'

const styles = (t: Theme) => createStyles({
  root: {
    padding: t.spacing.unit * 3,
  },
})

interface IProps extends WithI18n,
  WithGlobalProgress,
  WithToast,
  RouteComponentProps<any>,
  WithStyles<typeof styles>,
  ReturnType<typeof state2props> {
}


class Dashboard extends React.Component<IProps, {}> {

  render() {
    const { t, classes, user } = this.props
    return (
      <div className={classes.root}>
        <Helmet>
          <title>{t.App_title_page_Dashboard}</title>
        </Helmet>
        <Page width="80%">
          <Grid container>
            <Grid item xs={12}>
              <MailNotification
                activeLabel={t.user_notification_active_label}
                inactiveLabel={t.user_notification_inactive_label}
              />
            </Grid>
            <Grid item xs={12}>
              <IndexMiniChart
                config={DASHBOARD_INDEX_CONFIG}
                onClick={() => this.redirectTo(`market-indicators`)}
              />
            </Grid>
            <Grid item md={6} xs={12}>
              <DashboardHabilitations />
              <DashboardSignatures />
              <DashboardTransactions />
              {user.read_only_access ? null : <DashboardCotations />}
            </Grid>
            <Grid item md={6} xs={12}>
              <DashboardNews />
            </Grid>
          </Grid>
        </Page>
      </div>
    )
  }

  @autobind
  private redirectTo(url: string) {
    this.props.history.push(`/ptf/enterprise/${this.props.enterprise.id}/${url}`)
  }
}

const state2props = (state: RootState) => ({
  mapName: state.utils.mapCategories,
  mapProductType: state.utils.mapProductType,
  news: state.paginate.news.entities,
  user: state.accountInfo.connectedUser,
  enterprise: state.accountInfo.enterpriseSelected,
});

export default compose(
  withI18n,
  withRouter,
  withGlobalProgress,
  withToast,
  withStyles(styles),
  connect(state2props),
)(Dashboard)



// WEBPACK FOOTER //
// ./src/page/Consumer/Dashboard/Dashboard.tsx